import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import axiosAuth from "../../../axiosAuth";
import { SCHOOL_INSTALLMENTS_UPDATE } from "../../apiRoutes";

// ✅ Payload matches your API requirement
export interface UpdateInstallmentPayload {
  schoolId: string;
  installmentId: string; // <-- use this instead of index
  year: number;
  installmentNumber: number;
  expectedDueDate: string | null;
  installmentAmount: number;
  mouAmount: number;
  installmentPercentage: number;
  isPdcCheckAvailable: boolean;
}

export const useUpdateInstallmentMutation = (
  options?: { onSuccess?: () => void }
) => {
  return useMutation({
    mutationFn: async (payload: UpdateInstallmentPayload) => {
      const { schoolId, installmentId, ...rest } = payload;

      const body = Object.fromEntries(
        Object.entries(rest).filter(([, v]) => v !== null && v !== undefined)
      );

      // ✅ PUT to /school/installments/update/:installmentId/
      const response = await axiosAuth.put(
        `${SCHOOL_INSTALLMENTS_UPDATE}${installmentId}/`,
        body
      );

      return response.data;
    },

    onSuccess: () => {
      toast.success("Installment updated successfully!");
      options?.onSuccess?.();
    },

    onError: (error: any) => {
      const message =
        error?.response?.data?.issues?.message ||
        error?.response?.data?.message ||
        "Failed to update installment";
      toast.error(message);
    },
  });
};
